(function () {
  'use strict';

  let loadPromise = null;

  window.loadGoogleMaps = function () {
    if (loadPromise) return loadPromise;
    if (window.google && window.google.maps && window.google.maps.places) {
      loadPromise = Promise.resolve(window.google.maps);
      return loadPromise;
    }

    const apiKey = window.GOOGLE_MAPS_API_KEY;
    if (!apiKey) {
      console.warn('Google Maps API key not configured.');
      return Promise.reject(new Error('Missing Google Maps API key.'));
    }

    loadPromise = new Promise(function (resolve, reject) {
      const callbackName = '__onGoogleMapsLoaded_' + Date.now();
      window[callbackName] = function () {
        delete window[callbackName];
        resolve(window.google.maps);
      };

      const script = document.createElement('script');
      script.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        encodeURIComponent(apiKey) +
        '&libraries=places&callback=' +
        callbackName;
      script.async = true;
      script.defer = true;
      script.onerror = function () {
        delete window[callbackName];
        loadPromise = null;
        reject(new Error('Failed to load Google Maps.'));
      };
      document.head.appendChild(script);
    });

    return loadPromise;
  };

  function bindLazyLoad(input) {
    if (!input || input.dataset.gmapsBound === '1') return;
    input.dataset.gmapsBound = '1';
    const trigger = function () {
      window.loadGoogleMaps().then(function () {
        input.dispatchEvent(new CustomEvent('gmaps:ready', { bubbles: true }));
      }).catch(function (err) {
        console.error(err);
      });
    };
    input.addEventListener('focus', trigger, { once: true });
    input.addEventListener('pointerdown', trigger, { once: true });
  }

  function scan(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-gmaps-autocomplete]').forEach(bindLazyLoad);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
